'use strict';

import { initializeApp } from "firebase/app";
import { getAuth, } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyAyqQm-BaI7wuusy37HsQ-X5o2kVUwfyJg",
  authDomain: "qazando-github-actions.firebaseapp.com",
  projectId: "qazando-github-actions",
  storageBucket: "qazando-github-actions.firebasestorage.app",
  messagingSenderId: "966154882930",
  appId: "1:966154882930:web:836ede5e7cb1e80fc8d7eb",
  measurementId: "G-53PF5RPNG2"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
